export default __webpack_public_path__ + "static/media/SneakerSwipe5.33dd44fd.png";